
<template>
  <v-layout class="segment-list-item">
    <v-flex xs12 class="ma-0 pa-0">
      <v-btn class="text-none fill-width" small depressed @click="$emit('segmment-clicked',item)">
        <div class="fill-width">
          <div class="fill-width d-inline-flex">
            <img
              :src="$ic.getImageUrl('profile', profiler.calcProfile(item.segment))"
              class="medium-thumbnail"
              :class="item.segment.climb_category !== 0 ? 'image-color-warning' : 'image-accent-dark'"
            >
            <h3 class="primary--text font-weight-light text-xs-left ml-2">{{ item.segment.name }}</h3>
            <div class="ml-auto details-cell-container">
              <h5
                class="primary--text text-xs-right"
                v-html="$bc.distanceFormat(item.segment.distance,'minor')"
              />
              <h5
                class="primary--text data-cell ml-2"
                v-html="$bc.elevationFormat(elevation, true)"
              />
            </div>
          </div>
          <div style="display: flex;">
            <ul style="list-style: none;" class="ml-auto">
              <li v-for="(effort, index) in item.efforts" :key="`${effort.id}_${index}`">
                <div class="ml-auto d-inline-flex">
                  <div class="data-cell">
                    <div class="kom-box">
                      <img
                        v-if="effort.pr_rank"
                        :src="$ic.getImageUrl('rank',  effort.pr_rank)"
                        class="small-thumbnail mr-auto"
                      >
                      <img
                        v-if="effort.kom_rank"
                        :src="$ic.getImageUrl('kom',  effort.kom_rank)"
                        class="small-thumbnail mr-auto"
                        style="color: yellow;"
                      >
                      <div class="kom-text">{{ effort.kom_rank }}</div>
                    </div>
                  </div>
                  <h5
                    class="data-cell align-center"
                    :class="effort.pr_rank ? '' : 'text-muted'"
                  >{{ $bc.dateFormat(effort.start_date,'HH:mma') }}</h5>
                  <h5
                    class="data-cell align-center"
                    :class="effort.pr_rank ? '' : 'text-muted'"
                  >{{ $bc.timeFormat(effort.elapsed_time) }}</h5>
                  <h5
                    class="data-cell align-center"
                    :class="effort.pr_rank ? '' : 'text-muted'"
                    v-html="$bc.speedFormat(effort.distance/effort.elapsed_time)"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import profiler from '@/domain/ProfileAnalyzer';

export default {
  name: 'segment-effort-list-item',
  props: {
    item: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data: () => ({
    profiler,
  }),
  computed: {
    elevation() {
      return profiler.calcElevationDelta(this.item.segment);
    },
  },
  methods: {
  },
};
</script>

<style lang="scss">
.segment-list-item {
  .fill-width {
    width: 100%;
  }
  button {
    margin: 1px;
    height: auto;
  }
  .v-btn__content {
    justify-items: stretch;
    margin: 1px;
  }
  .data-cell {
    width: 80px;
    text-align: right;
  }
  .align-center {
    align-self: center;
  }
  .text-muted {
    opacity: 0.5;
  }
  .details-cell-container {
    display: inline-flex;
    flex-shrink: 1 !important;
    flex-grow: 0 !important;
  }
  .kom-box {
    position: relative;
    display: inline-block;
  }
  .kom-text {
    position: absolute;
    z-index: 999;
    left: 35%;
    top: 3%;
    color: white;
  }
}
</style>
